import { render, staticRenderFns } from "./AdminAISettings.vue?vue&type=template&id=55d3b077"
import script from "./AdminAISettings.vue?vue&type=script&lang=js"
export * from "./AdminAISettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports